var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApostrophe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_619_3424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6089 7.61045C18.4082 9.47965 19.3073 12.0656 19.3064 15.3687C19.3064 22.5607 14.4629 29.1659 4.77554 35.1836L3.78492 33.6452C10.6112 29.1682 14.0238 24.6915 14.0226 20.2149C14.0226 20.1613 14.0141 20.1171 14.0141 20.0654C11.861 21.9604 8.89249 22.6319 6.13358 21.8484C3.3742 21.0647 1.20209 18.933 0.366146 16.189C-0.469795 13.4451 0.145832 10.4644 2.00009 8.27587C2.10054 8.14395 2.2329 8.02363 2.34206 7.89729C2.39495 7.84127 2.44339 7.78524 2.49741 7.73145C2.69384 7.49574 2.90366 7.27163 3.12576 7.06025C4.81279 5.55465 7.0329 4.80196 9.78576 4.80219C12.5387 4.80219 14.813 5.73814 16.6086 7.61025L16.6089 7.61045ZM37.3031 7.61156C39.1011 9.48076 40 12.0672 40 15.371C40 22.5607 35.1569 29.1653 25.4703 35.1836L24.4783 33.6443C31.1629 29.2583 34.5509 24.8745 34.6898 20.4923C32.9061 21.8438 30.6574 22.4287 28.4412 22.1171C26.2251 21.8057 24.2247 20.6237 22.8827 18.8329C21.5408 17.042 20.968 14.7903 21.2912 12.5757C21.2912 12.5501 21.287 12.5327 21.287 12.5085C21.287 10.3817 22.131 8.56592 23.8189 7.061C25.5068 5.55609 27.7267 4.80409 30.4789 4.80478C33.2304 4.80478 35.5055 5.74026 37.3035 7.61146L37.3031 7.61156Z",
    fill: "#F4F4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_619_3424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApostrophe);
export default __webpack_public_path__ + "static/media/Apostrophe.139a692bf112576231b45feb0baf6a4d.svg";
export { ForwardRef as ReactComponent };